var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPaginationNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 42 42"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "icon-paginationNext_svg__a",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon-paginationNext_svg__b",
    d: "M.25 10.474l4.296-4.486L.269 1.523a.91.91 0 010-1.256A.862.862 0 011.5.248l4.434 4.63.92.957.147.153-1.062 1.114-4.439 4.63a.863.863 0 01-1.23.019.917.917 0 01-.02-1.277z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    stroke: "#1BB2C5",
    transform: "matrix(-1 0 0 1 41 1)",
    xlinkHref: "#icon-paginationNext_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18 15)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon-paginationNext_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon-paginationNext_svg__b"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#1BB2C5",
    mask: "url(#icon-paginationNext_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-9-6h24v24H-9z"
  }))))));
}

export default SvgIconPaginationNext;